import { useEffect, useState, useContext, useRef } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { addToCartAndOrderExpress } from "../utils/addToCartAndOrderExpress";
import { API_BASE } from "../utils/api";
import { FaShoppingCart, FaPencilAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { getMyAccountId } from "../utils/config";
import { useLanguage } from "../context/LanguageContext";

export default function ProductDetail() {
  const { productId } = useParams();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const { addToCart, setCartItems } = useContext(CartContext);

  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [inputVal, setInputVal] = useState("1");
  const [editingNotes, setEditingNotes] = useState(false);
  const textareaRef = useRef(null);
  const [notesValue, setNotesValue] = useState("");
  const [currentNote, setCurrentNote] = useState("");
  const [isProformaMode, setIsProformaMode] = useState(
    () => localStorage.getItem("order_mode") === "proforma"
  );

  useEffect(() => {
    const sync = () => setIsProformaMode(localStorage.getItem("order_mode") === "proforma");
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  const MYACCOUNT_ID = getMyAccountId();
  const location = useLocation();
  const suggestedQty = location.state?.qty || 1;
  const { t } = useLanguage();

  useEffect(() => {
    const n = Number(suggestedQty) || 1;
    setQty(n);
    setInputVal(String(n));
  }, [suggestedQty]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productId]);

  useEffect(() => {
    if (!productId) return;
    const id_customer = user?.idCustomer || "";
    fetch(
      `${API_BASE}/inventary-ultra/api/ws/get_productById` +
      `?id_product=${productId}` +
      (id_customer ? `&id_customer=${id_customer}` : "")
    )
      .then(async (res) => {
        if (!res.ok) throw new Error(await res.text());
        return res.json();
      })
      .then(setProduct)
      .catch((err) => console.error("Error cargando producto:", err.message));
  }, [productId]);

  useEffect(() => {
    if (editingNotes && textareaRef.current) {
      textareaRef.current.focus({ preventScroll: true });
    }
  }, [editingNotes]);

  useEffect(() => {
    if (!product) return;
    const expressItems = JSON.parse(localStorage.getItem("order_express_items") || "[]");
    const expressItem = expressItems.find(it => it.code === product.productId);
    if (expressItem?.notes) setCurrentNote(expressItem.notes);
  }, [product]);

  if (!product) {
    return <p className="pt-28 text-center">Cargando producto...</p>;
  }

  const hasCustomNote = currentNote && currentNote !== product.productName;

  return (
    <div className="pt-16 bg-gray-50">
      <div className="px-6 lg:px-12 max-w-7xl mx-auto py-8">

        {/* BACK */}
        <div className="mb-6">
          <button
            onClick={() => history.goBack()}
            className="inline-flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-sm font-semibold text-gray-600 bg-white hover:bg-gray-50 shadow-sm transition"
          >
            <span>←</span>
            {t.btnBack}
          </button>
        </div>

        {/* CONTENIDO: card + botón hermano a la derecha */}
        <div className="flex items-start gap-4 -mt-6">

          {/* CARD */}
          <div className="flex-1 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">

              {/* IMAGEN */}
              <div className="relative bg-gray-50 flex items-center justify-center p-12 lg:border-r border-gray-100 min-h-[480px]">
                {/* ETIQUETA IVA - pill (solo se marca la excepcion: productos exentos) */}
                {user && !product.payTax && (
                  <div className="absolute top-4 right-4 bg-amber-500 text-white text-[12px] font-bold px-2 py-1 rounded-md shadow-sm z-10 whitespace-nowrap">
                    Exento de IVA
                  </div>
                )}
                <img
                  src={`https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${product.productId}.jpg`}
                  onError={(e) => (e.target.src = "https://www.ultra-erp.pro/products/no_image.jpg")}
                  className="max-h-[460px] object-contain drop-shadow-sm"
                  alt={product.productName}
                />
              </div>

              {/* INFO */}
              <div className="p-8 flex flex-col">

                {/* Nombre */}
                <p className="text-xl font-bold text-gray-900 leading-tight mb-2">
                  <span
                    className="px-1 rounded"
                    style={hasCustomNote ? { backgroundColor: '#00D2D2' } : {}}
                  >
                    {currentNote || product.productName}
                  </span>
                </p>

                {/* Editor de notas */}
                {editingNotes && (
                  <div className="mb-3 flex flex-col gap-2">
                    <textarea
                      ref={textareaRef}
                      maxLength={75}
                      rows={5}
                      value={notesValue}
                      onChange={(e) => setNotesValue(e.target.value)}
                      className="w-full border rounded-lg px-3 py-2 text-xl font-bold shadow-sm resize-none focus:outline-none focus:ring-2 focus:ring-brand-primary"
                    />
                    <div className="flex gap-2">
                      <button
                        onClick={() => {
                          setCartItems(prev => prev.map(c =>
                            (c.code === product.productId || c.productId === product.productId)
                              ? { ...c, notes: notesValue }
                              : c
                          ));
                          setCurrentNote(notesValue);
                          setEditingNotes(false);
                        }}
                        className="px-4 py-1.5 bg-brand-primary text-white text-sm font-semibold rounded-lg hover:brightness-90 transition"
                      >
                        Aceptar
                      </button>
                      <button
                        onClick={() => setEditingNotes(false)}
                        className="px-4 py-1.5 border border-gray-300 text-gray-600 text-sm rounded-lg hover:bg-gray-100 transition"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}
                <p className="text-gray-600 text-sm mb-3">
                  Código: <span className="font-bold">{product.productId}</span>
                </p>

                {/* Descripción */}
                {product.description && (
                  <p className="text-gray-700 text-sm leading-relaxed pb-4 mb-4 border-b border-gray-100">
                    {product.description}
                  </p>
                )}

                {/* Precio + cantidad + botón */}
                {user ? (
                  <div className="mt-0">
                    <p className="text-3xl font-extrabold text-brand-primary mb-5">
                      ${Number(product.unitPrice).toFixed(4)}
                    </p>

                    <div className="mb-5">
                      <label className="block text-gray-700 font-medium mb-1">
                        Cantidad
                      </label>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => { const n = Math.max(1, qty - 1); setQty(n); setInputVal(String(n)); }}
                          className="w-9 h-9 rounded-lg border border-gray-200 text-xl font-bold text-gray-500 hover:bg-gray-50 transition flex items-center justify-center select-none"
                        >
                          −
                        </button>
                        <input
                          type="number"
                          min="1"
                          value={inputVal}
                          onChange={(e) => setInputVal(e.target.value)}
                          onBlur={(e) => {
                            const n = Math.max(1, Number(e.target.value) || 1);
                            setQty(n);
                            setInputVal(String(n));
                          }}
                          onFocus={(e) => e.target.select()}
                          className="w-24 border border-gray-200 rounded-lg px-3 py-2 text-center text-lg font-bold shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-primary"
                        />
                        <button
                          onClick={() => { const n = qty + 1; setQty(n); setInputVal(String(n)); }}
                          className="w-9 h-9 rounded-lg border border-gray-200 text-xl font-bold text-gray-500 hover:bg-gray-50 transition flex items-center justify-center select-none"
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <button
                      onClick={() =>
                        addToCartAndOrderExpress({
                          product, qty, user, addToCart,
                          notes: hasCustomNote ? currentNote : null,
                        })
                      }
                      className={`w-full py-3.5 rounded-xl flex items-center justify-center gap-2 text-lg font-semibold hover:brightness-90 transition text-black ${isProformaMode ? "bg-[#FFFFB3]" : "bg-[#80FF80]"}`}
                    >
                      <FaShoppingCart />
                      {isProformaMode ? "Agregar a Solicitud de Proforma" : t.btnAddToCar}
                    </button>
                  </div>
                ) : (
                  <div className="mt-0 border-t border-gray-100 pt-5">
                    <p className="text-sm text-gray-600 mb-3">
                      Inicie sesión para ver precios y realizar órdenes.
                    </p>
                    <Link
                      to="/login"
                      className="inline-block text-sm font-semibold text-brand-primary hover:underline"
                    >
                      Ir a Iniciar Sesión →
                    </Link>
                  </div>
                )}

              </div>
            </div>
          </div>

          {/* NUEVO PRODUCTO - hermano del card, fuera y a la derecha */}
          {user?.swWeb14 && !editingNotes && (
            <div className="relative group shrink-0 mt-2">
              <button
                className="flex flex-col items-center gap-1.5 px-3 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-500 hover:border-brand-primary hover:text-brand-primary hover:bg-brand-primary/10 shadow-sm transition-all text-xs font-medium"
                onClick={() => {
                  setNotesValue(currentNote || product.productName);
                  setEditingNotes(true);
                }}
              >
                <FaPencilAlt size={14} />
                <span className="text-center leading-tight">Nuevo<br />Producto</span>
              </button>
              <div className="absolute right-full top-1/2 -translate-y-1/2 mr-2 hidden group-hover:block z-50 pointer-events-none">
                <div className="bg-gray-800 text-white text-sm rounded-lg py-2 px-3 w-52 leading-snug shadow-lg">
                  Presione este boton si Ud. quiere editar la descripción 
                   o desea solicitar un producto similar con esta nueva descripción.
                </div>
                <div className="w-2 h-2 bg-gray-800 rotate-45 absolute top-1/2 -translate-y-1/2 -right-1" />
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
